import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkDocCategoryIsObjectAndDocTypeAllowedRule: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
	const documentCategory = control.get('documentCategory')!.value;
	const documentType = control.get('documentType')!.value;
	const coverProcessId = control.get('coverProcessId')!.value;
	const foreignCustomerId = control.get('foreignCustomerId')!.value;
	const documentTypeArray = ['EGD018', 'EGD020', 'EGD031', 'EGD033'];

	return (!coverProcessId && !foreignCustomerId) && !!documentType && documentCategory ===  "EGD05"
	            && !documentTypeArray.includes(documentType)  ? { checkDocCategoryIsObjectAndDocTypeAllowedFlag: true } : null;
};
